import { IListings } from 'src/interface';
import useSWR from 'swr';
import { useEffect, useState } from 'react';

const useCustomSearchListings = (
  SSRListings: IListings,
  shouldFetch: any,
  perPage: number | string,
  fetcher: (url: string, params: any) => Promise<any>
) => {
  const { data: result } = useSWR<null | { listings: IListings }>(shouldFetch, fetcher);
  const [listings, setListings] = useState(SSRListings);

  useEffect(() => {
    if (result) {
      setListings(result.listings);
    }
  }, [result]);

  useEffect(() => {
    if (SSRListings.data.length) {
      setListings(SSRListings);
    }
  }, [SSRListings]);
  if (SSRListings.data.length === 0) {
    return {
      isLoading: false,
      canLoadMore: false,
      Listings: null,
    };
  }
  return {
    isLoading: perPage > 10 && !result,
    canLoadMore: listings && listings.total > perPage,
    Listings: listings,
  };
};
export default useCustomSearchListings;
